/**
 * BandeauEnvironnement — sur le poste de développement, dit en haut de CHAQUE écran
 * qu'on regarde le banc local et pas le site.
 *
 * Du 22/09 au 29/10/2026, il disait aussi, sur le site, laquelle des deux ServUp on
 * avait sous les yeux (l'ancienne et servup4i tournaient en parallèle). L'ancienne
 * est arrêtée : sur le site, plus de bandeau (décision du 30/10/2026).
 *
 * Il est posé au-dessus de tout (y compris l'écran de connexion et celui du second
 * facteur). Sa hauteur vit dans la variable CSS `--bandeau-env` (styles/main.css),
 * utilisée par le corps de page et par la barre latérale fixe : le bandeau ne
 * recouvre rien, et sans bandeau (`data-bandeau-env` absent) elle vaut 0.
 */

import { environnementCourant } from '../../utils/environnement';

function BandeauEnvironnement() {
  const env = environnementCourant();
  if (!env) return null;

  return (
    <div
      data-bandeau-env={env.cle}
      role="status"
      aria-label={`Environnement : ${env.libelle}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: 'var(--bandeau-env)',
        zIndex: 5000,
        backgroundColor: env.couleur,
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '8px',
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '12px',
        fontWeight: 700,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        userSelect: 'none',
        boxShadow: '0 1px 3px rgba(0,0,0,0.25)'
      }}
    >
      <span style={{ fontSize: '11px', opacity: 0.85 }}>●</span>
      <span style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        padding: '0 12px'
      }}>
        {env.libelle}
      </span>
    </div>
  );
}

export default BandeauEnvironnement;
